// extracted by mini-css-extract-plugin
module.exports = {"wrap":"About_wrap__3dqZO","container":"About_container__vm32Q","preloader":"About_preloader__3sLU-","error":"About_error__1105h","subtitle":"About_subtitle__2cC3U"};